import { render, staticRenderFns } from "./CollapsableBlock.vue?vue&type=template&id=a5cd4db0"
import script from "./CollapsableBlock.vue?vue&type=script&lang=js"
export * from "./CollapsableBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/devstark/spreadsimple/spreadsimple-app/main-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a5cd4db0')) {
      api.createRecord('a5cd4db0', component.options)
    } else {
      api.reload('a5cd4db0', component.options)
    }
    module.hot.accept("./CollapsableBlock.vue?vue&type=template&id=a5cd4db0", function () {
      api.rerender('a5cd4db0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/collapsable-block/CollapsableBlock.vue"
export default component.exports